import Vue from 'vue';
import VueI18n from 'vue-i18n';

import { languages, defaultLocale, fallbackLocale } from './translations';

Vue.use(VueI18n);

const messages = Object.assign(languages);

// from https://medium.freecodecamp.org/how-to-add-internationalization-to-a-vue-application-d9cfdcabb03b

const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale,
  silentTranslationWarn: true,
  messages, // set locale messages
});

export default i18n;
